import { useQuery, UseQueryResult } from 'react-query';
import getConfig from 'next/config';
import axios from 'axios';
import { API_PATHS, HOST_BASE_URL } from 'common/utils/constants/api.constants';
import { CmsCollections } from 'common/utils/constants/cms.constants';

const { publicRuntimeConfig } = getConfig();

export const useCms = <T>(collection: CmsCollections): UseQueryResult<T, Error> => {
  return useQuery(
    ['cms-data', collection],
    () => axios.get(`${HOST_BASE_URL}${API_PATHS.CMS}/${collection}`).then((res) => res.data),
    {
      keepPreviousData: true,
      // in milliseconds
      refetchInterval: publicRuntimeConfig.cmsRefetchInterval * 1000,
      cacheTime: publicRuntimeConfig.cmsRefetchInterval * 1000,
    }
  );
};

export const useCmsWithQuerySingle = <T>(
  collection: CmsCollections,
  queryField: string,
  queryValue: number
): UseQueryResult<T, Error> => {
  return useQuery(
    ['cms-data', collection],
    () =>
      axios
        .get(`${HOST_BASE_URL}${API_PATHS.CMS}/${collection}`, {
          params: {
            queryField: queryField,
            queryValue: queryValue,
          },
        })
        .then((res) => res.data),
    {
      keepPreviousData: true,
      // in milliseconds
      refetchInterval: publicRuntimeConfig.cmsRefetchInterval * 1000,
      cacheTime: publicRuntimeConfig.cmsRefetchInterval * 1000,
    }
  );
};
